module.exports = __webpack_public_path__ + "static/media/today.90f80315.png";